/**
 * CSV Box script loader.
 * Loads the CSV Box script when called (e.g. from a hook or app mount).
 */

const CSVBOX_SCRIPT_URL = 'https://js.csvbox.io/script.js';

export function loadCsvBox(): void {
  if (document.querySelector(`script[src="${CSVBOX_SCRIPT_URL}"]`)) {
    return;
  }

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = CSVBOX_SCRIPT_URL;
  script.async = true;
  document.head.appendChild(script);
}
